import { showError } from '@utils';
import { useEffect } from 'react';

export const useFleetVehicleErrors = ({
  errorMessage,
  changelogResponse,
  servicePointsAllResponse,
  insurancesResponse,
  roadsideAssistancesResponse,
  colorsResponse,
  dealersResponse,
  providersResponse,
}) => {
  useEffect(() => {
    const errors = [
      errorMessage,
      changelogResponse?.error,
      servicePointsAllResponse?.error,
      insurancesResponse?.error,
      roadsideAssistancesResponse?.error,
      colorsResponse?.error,
      dealersResponse?.error,
      providersResponse?.error,
    ].filter(Boolean);

    errors.forEach(showError);
  }, [
    errorMessage,
    changelogResponse?.error,
    servicePointsAllResponse?.error,
    insurancesResponse?.error,
    roadsideAssistancesResponse?.error,
    colorsResponse?.error,
    dealersResponse?.error,
    providersResponse?.error,
  ]);
};
